import { Grid, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { soloNumero } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { EstatusField, LoadingWidget } from '../../../../widgets';
import SelectFieldMateriasComponent from '../../../control_estudios/materias/components/SelectFieldMaterias';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { saveTemasAcademicosAction } from '../TemasAcademicosAction';

const FormTemasAcademicos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const materiasStore = Redux.useSelector((state) => state.materias);
  const temasAcademicosStore = Redux.useSelector(
    (state) => state.temasAcademicos,
  );

  const activo = temasAcademicosStore.activo;

  const [materias, setMaterias] = React.useState([]);

  const initData = {
    titulo: '',
    referencia: '',
    link: '',
    desc: '',
    numero: 1,
    idMateria: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    titulo: false,
    referencia: false,
    link: false,
    numero: false,
    desc: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (loginStore.isAdminTeacher) {
      materiasStore.all.forEach((el) => setMaterias((prev) => [...prev, el]));
      return;
    }

    docentesStore.activo.materias.forEach((el) =>
      setMaterias((prev) => [...prev, el.materia]),
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));

    let idMateria = '';
    if (activo.materias.length === 1) {
      idMateria = activo.materias[0].materia.id;
    }

    setTimeout(
      () =>
        setData({
          ...values,
          idMateria,
          idEstatus: activo.estatus.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!data.idMateria && !activo) {
      notify('Falta seleccionar una materia', { warnin: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveTemasAcademicosAction(
        { dispatch, notify },
        activo?.id,
        data,
        temasAcademicosStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}
        {(!activo || activo?.materias.length === 1) && (
          <Grid item xs={12} md={5}>
            <SelectFieldMateriasComponent
              value={data.idMateria}
              isAll={false}
              data={loginStore.isAdminTeacher ? null : materias}
              onChange={(idMateria) =>
                _handleSetDataField(CONST.materia.idName, idMateria)
              }
            />
          </Grid>
        )}
        <Grid item xs={12} md={7}>
          <TextField
            fullWidth
            size="small"
            id={CONST.titulo.name}
            required
            label={CONST.titulo.label}
            value={data.titulo}
            onChange={(e) =>
              _handleSetDataField(
                CONST.titulo.name,
                e.target.value.toUpperCase(),
              )
            }
            helperText={dataError.titulo ? validMessage.required : null}
            error={dataError.titulo}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.referencia.name}
            required
            label={CONST.referencia.label}
            value={data.referencia}
            onChange={(e) =>
              _handleSetDataField(CONST.referencia.name, e.target.value)
            }
            helperText={dataError.referencia ? validMessage.required : null}
            error={dataError.referencia}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.link.name}
            required
            label={CONST.link.label}
            value={data.link}
            onChange={(e) =>
              _handleSetDataField(CONST.link.name, e.target.value)
            }
            helperText={dataError.link ? validMessage.required : null}
            error={dataError.link}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            type="number"
            fullWidth
            size="small"
            id={CONST.numero.name}
            required
            label={CONST.numero.label}
            value={data.numero}
            onChange={(e) =>
              _handleSetDataField(CONST.numero.name, soloNumero(e.target.value))
            }
            helperText={dataError.numero ? validMessage.required : null}
            error={dataError.numero}
            InputProps={{
              inputProps: { min: 1, max: 20 },
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <EstatusField
            value={data.idEstatus}
            onChange={(e) =>
              _handleSetDataField(CONST.estatus.idName, e.target.value)
            }
            isEstatus
            required
            error={dataError.estatus}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            required
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormTemasAcademicos;
